var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeeTitleBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 250,
    viewBox: "0 0 380 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M219,428V184.491a199.4,199.4,0,0,1,61.235-9.575c94.724,0,174.088,66.049,194.906,154.775A97.8,97.8,0,0,1,553.9,289.934q3.38,0,6.7.226A118.707,118.707,0,0,1,599,257.1V428ZM473.675,300.934a6.793,6.793,0,1,1,6.793,6.809A6.8,6.8,0,0,1,473.675,300.934Zm55.426-36a17.791,17.791,0,1,1,17.791,17.834A17.813,17.813,0,0,1,529.1,264.934Zm-17.425-4.525a3.293,3.293,0,1,1,3.293,3.31A3.3,3.3,0,0,1,511.676,260.409Z",
    transform: "translate(-219 -175.787)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeTitleBackground);
export default __webpack_public_path__ + "static/media/employee_title-background.933562fea3daa50e45d16d04090e0005.svg";
export { ForwardRef as ReactComponent };